export class EcommerceVk {
	PRICE_LIST_ID = 154711;

	homeView(products) {
		let eventParams = {
			"products": this.getProductsList(products),
			"category_ids": this.getProductsCategoryIds(products),
			"currency_code": "RUB"
		};

		VK.Retargeting.ProductEvent(this.PRICE_LIST_ID, "view_home", eventParams);
	}

	categoryView(products) {
		let eventParams = {
			"products": this.getProductsList(products),
			"category_ids": this.getProductsCategoryIds(products),
			"currency_code": "RUB"
		};

		VK.Retargeting.ProductEvent(this.PRICE_LIST_ID, "view_category", eventParams);
	}

	productView(products) {
		let eventParams = {
			"products": this.getProductsList(products),
			"category_ids": this.getProductsCategoryIds(products),
			"currency_code": "RUB",
			"total_price": this.getProductsTotal(products)
		};

		VK.Retargeting.ProductEvent(this.PRICE_LIST_ID, "view_product", eventParams);
	}

	searchView(searchString, products) {
		let eventParams = {
			"products": this.getProductsList(products),
			"category_ids": this.getProductsCategoryIds(products),
			"currency_code": "RUB",
			"search_string": searchString
		};

		VK.Retargeting.ProductEvent(this.PRICE_LIST_ID, "view_search", eventParams);
	}

	otherView() {
		let eventParams = {};

		VK.Retargeting.ProductEvent(this.PRICE_LIST_ID, "view_other", eventParams);
	}

	addToWishList(products) {
		let eventParams = {
			"products": this.getProductsList(products),
			"category_ids": this.getProductsCategoryIds(products),
			"currency_code": "RUB"
		};

		VK.Retargeting.ProductEvent(this.PRICE_LIST_ID, "add_to_wishlist", eventParams);
	}

	removeFromWishList(products) {
		let eventParams = {
			"products": this.getProductsList(products),
			"category_ids": this.getProductsCategoryIds(products),
			"currency_code": "RUB"
		};

		VK.Retargeting.ProductEvent(this.PRICE_LIST_ID, "remove_from_wishlist", eventParams);
	}

	addToCart(products) {
		let eventParams = {
			"products": this.getProductsList(products),
			"category_ids": this.getProductsCategoryIds(products),
			"currency_code": "RUB",
			"total_price": this.getProductsTotal(products)
		};

		VK.Retargeting.ProductEvent(this.PRICE_LIST_ID, "add_to_cart", eventParams);
	}

	removeFromCart(products) {
		let eventParams = {
			"products": this.getProductsList(products),
			"category_ids": this.getProductsCategoryIds(products),
			"currency_code": "RUB",
			"total_price": this.getProductsTotal(products)
		};

		VK.Retargeting.ProductEvent(this.PRICE_LIST_ID, "remove_from_cart", eventParams);
	}

	initCheckout(products) {
		let eventParams = {
			"products": this.getProductsList(products),
			"category_ids": this.getProductsCategoryIds(products),
			"currency_code": "RUB",
			"total_price": this.getProductsTotal(products)
		};

		VK.Retargeting.ProductEvent(this.PRICE_LIST_ID, "init_checkout", eventParams);
	}

	purchase(products) {
		let eventParams = {
			"products": this.getProductsList(products),
			"category_ids": this.getProductsCategoryIds(products),
			"currency_code": "RUB",
			"total_price": this.getProductsTotal(products)
		};

		VK.Retargeting.ProductEvent(this.PRICE_LIST_ID, "purchase", eventParams);
	}

	getProductsList(products) {
		return products.map((item, key) => {
			const result = {
				id: item.id,
				group_id: item.categoryId,
				price: item.price,
				price_old: item.oldPrice
			}

			if (item.recommended) {
				result.recommended_ids = item.recommended;
			}

			return result;
		});
	}

	getProductsTotal(products) {
		let total = 0;
		products.forEach(item => {
			total += parseInt(item.price);
		});

		return total;
	}

	getProductsCategoryIds(products) {
		let categoryIds = [];
		products.forEach(item => {
			categoryIds.push(item.categoryId);
		});

		return Array.from(new Set(categoryIds)).join(',') || '';
	}
} 